'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var PropTypes = require('prop-types');
var styled = require('styled-components');
var constants = require('../constants.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const getTemplate = config => props => {
  const {
    propNames,
    propNameMap,
    breakpointWidths,
    cssTemplate
  } = config;
  return propNames.reduce((css, propName) => {
    const breakpoint = propNameMap[propName];
    const breakpointWidth = breakpointWidths[breakpoint];
    let value = props[propName];
    if (typeof value === 'function') {
      value = value(props, {
        css,
        propName,
        breakpoint,
        breakpointWidth
      }, config);
    }
    if (typeof value !== 'string') return css;
    const newCss = cssTemplate({
      breakpointWidth,
      value
    });
    if (typeof newCss !== 'string') return css;
    return `${css} ${newCss}`;
  }, '');
};
const getConfig = _ref => {
  let {
    prefix,
    suffix,
    breakpointWidths
  } = _ref;
  return Object.keys(breakpointWidths).reduce((_ref2, nextBreakpoint) => {
    let {
      propNameMap,
      propNames,
      propTypes
    } = _ref2;
    const newPropName = `${prefix}${nextBreakpoint}${suffix}`;
    return {
      propNameMap: {
        ...propNameMap,
        [newPropName]: nextBreakpoint
      },
      propNames: [...propNames, newPropName],
      propTypes: {
        ...propTypes,
        [newPropName]: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].func])
      }
    };
  }, {
    propNameMap: {},
    propNames: [],
    propTypes: {}
  });
};
var styledBreakpoint = (function () {
  let {
    prefix = '',
    suffix = '-style',
    breakpointWidths = constants.breakpointMinWidths,
    cssTemplate = _ref3 => {
      let {
        breakpointWidth,
        value
      } = _ref3;
      return `@media (min-width: ${breakpointWidth}) { ${value} }`;
    },
    defaultProps = {}
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return component => {
    const {
      propNameMap,
      propNames,
      propTypes
    } = getConfig({
      prefix,
      suffix,
      breakpointWidths
    });
    const template = getTemplate({
      propNameMap,
      propNames,
      propTypes,
      breakpointWidths,
      cssTemplate
    });
    const StyledBreakpoint = styled__default["default"](component).withConfig({
      componentId: "sc-u2kmlc-0"
    })(["", ""], template);
    StyledBreakpoint.propTypes = propTypes;
    StyledBreakpoint.defaultProps = defaultProps;
    return {
      propNameMap,
      propNames,
      propTypes,
      template,
      component: StyledBreakpoint
    };
  };
});

exports["default"] = styledBreakpoint;
exports.getConfig = getConfig;
exports.getTemplate = getTemplate;
